import {
    getData,
} from './Services'

export const getBarrios = async (id) => {
    const res = await getData(`/localidades/localidades_barrios/${id}`); 
    const data = res || [];  
    const barriosTransformados = data
        .filter(p => p.barrio_descripcion) // filtra los nulos
        .map(p => {
            const descripcion = p.barrio_descripcion.toLowerCase()
                .replace(/\b\w/g, l => l.toUpperCase()); // Capitaliza cada palabra
            return {
                id: p.id,
                value: descripcion,
                label: descripcion
            };
        });
    return barriosTransformados
}
